var LogoutMV = /** @class */ (function () {
    function LogoutMV() {
    }
    LogoutMV.clearMiddlewares = function () {
        LogoutMV.middlewares.clear();
    };
    LogoutMV.registerLogoutMiddleWare = function (middlewareName, middleware) {
        console.log('注册注销拦截器------>', middlewareName);
        if (!middleware) {
            return;
        }
        if (!!LogoutMV.middlewares.get(middlewareName)) {
            return;
        }
        LogoutMV.middlewares.set(middlewareName, middleware);
    };
    LogoutMV.execute = function () {
        LogoutMV.middlewares.forEach(function (middleware) {
            middleware && middleware();
        });
    };
    LogoutMV.middlewares = new Map();
    return LogoutMV;
}());
export default LogoutMV;

//# sourceMappingURL=LogoutMW.js.map
